import { io, type Socket } from "socket.io-client";
import { loadSettings } from "./settings";
import { isTauriSync } from "./tauri";
import { isCapacitor } from "./capacitor";

let current: Socket | null = null;

export function connectSocket(): Socket {
  const { server_url, token } = loadSettings();
  if (!server_url) throw new Error("Server URL ontbreekt");
  if (current) {
    current.disconnect();
    current = null;
  }
  const url = server_url.replace(/\/$/, "");
  const native = isTauriSync() || isCapacitor();
  // Native shells (Tauri-MSI, Android-APK): token gaat in de auth-
  // payload. PWA-browser: cookie-auth via withCredentials.
  const s = io(url, {
    path: "/socket.io/",
    transports: ["websocket"],
    auth: native ? { token } : {},
    withCredentials: !native,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
    reconnectionDelayMax: 10_000,
  });
  current = s;
  return s;
}

export function getSocket(): Socket | null {
  return current;
}

export function disconnectSocket(): void {
  if (current) {
    current.disconnect();
    current = null;
  }
}

/** Android-APK: socket expliciet sluiten wanneer de app naar de
 *  achtergrond gaat. De server beslist "geen open socket → FCM-push";
 *  zonder deze expliciete close blijft de bevroren WebView-socket
 *  server-side nog tot ~1 minuut als 'online' geregistreerd (socket.io
 *  ping-timeout) en werden berichten in dat venster nooit als melding
 *  afgeleverd. Handlers blijven op de instantie staan, dus resumeSocket
 *  hoeft alleen opnieuw te verbinden. */
export function pauseSocket(): void {
  current?.disconnect();
}

export function resumeSocket(): void {
  current?.connect();
}
